import { Container } from "@mui/material";

import FormLogin from "../components/FormLogin";

// Login page, accessible via /login, where the user
// can enter their email to receive a code, then enter the code to log in.
//
// If the user is already authenticated, they are redirected to the dashboard.
export default function Login() {
    return (
        <Container>
            <FormLogin />
        </Container>
    );
}